export const newsArticles = [
  {
    id: 'ddwvr-july-thank-you-bbq',
    title: 'DDWVR July Thank You BBQ',
    date: '2015-07-02',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/ddwvr-bbq-2015.jpg',
    excerpt: 'Bel-Aire Mechanical held a Thank You BBQ for the field crew working on the Desert Diamond West Valley Resort Project to recognize their hard work and dedication.',
    content: `
      <h3>Desert Diamond West Valley Resort</h3>
      
      <p>On Thursday July 2, 2015, Bel-Aire Mechanical held a 'Thank You BBQ' for the field crew working on the Desert Diamond West Valley Resort Project.</p>
      
      <p>The 1st phase of the project has been on a very tight schedule from the start and Bel-Aire continues to lead the charge. It seemed appropriate to take this opportunity to thank our crew for their hard work and dedication to this high profile project and also prepare for the 4th of July holiday weekend.</p>
      
      <p>Robert Dustman (Sr. Project Manager) thanked the entire TEAM for their efforts in working safely and keeping up with the project milestones. Nick Ganem (Vice President) also shared some kind words of thanks and reiterated the importance that each worker has contributed to the success of this project and Jeff Goracke (Safety Coordinator) thanked everyone for working safely and reminded everyone to keep up the good work!</p>
      
      <p>Special thanks go out to our own GRILL-MASTER Steve Donovan, Jeremy Harwood, Andre Thom, Hector Fernandez, Katie Watson-Cruz, Sheryl Wolfe and Kim Dustman for setting up and grilling over 200 cheeseburgers and hot dogs! Stay tuned for future updates on this exciting project as well as others.</p>
    `
  },
  {
    id: 'roxann-retirement',
    title: 'Roxann Retirement',
    date: '2015-07-10',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/roxann-retirement-2015.jpg',
    excerpt: 'Celebrating the retirement of Roxann Markins, Administration Director, after 19 years of dedication and service to Bel-Aire Mechanical.',
    content: `
      <h3>Roxann Markins – Retirement Celebration</h3>
      
      <p>It was a full house in the Bel-Aire lunchroom as family, co-workers, and friends gathered to celebrate the retirement of Roxann Markins. Roxann was the Administration Director for Bel-Aire Mechanical. After 19-years with Bel-Aire, she is ready to join her husband Don in retirement and enjoy time and traveling with friends and family.</p>
      
      <p>Roxann played an intricate role in the success and growth of Bel-Aire Mechanical. Her loyalty and dedication to our company along with her caring attitude for people is unmatched.</p>
      
      <p>Jim Dinan (Bel-Aire President and CEO/Owner) spoke of his time with Roxann. Jim's speech was light-hearted but heartfelt. From the early days of typing and faxing proposals, to Roxann's growing knowledge and expertise of the sheet metal, plumbing, and piping project parts and pieces, and to her performing every role of the company at one time or another except go out in the field and install the product.</p>
      
      <p>Jim closed his speech with a few meaningful quotes and warm words, "…and everything you get for the rest of your life, you've earned it. You deserve it, you earned it. I never heard you once say the word no. You never once said we can't do it. You never once said 'I don't think we are going to… I have a problem with this'. We just did it, and we did it very well. And the people that work here now, and what you've done, down what I call the Admin Corridor, are a testament to how we just grew this thing up together. There is an author, his name is M.K. Soni. He says 'Retire from work, but not from life.' Congratulations, keep life going forward."</p>
      
      <p>Roxann showed her emotions too. She was proud and deeply honored to be a part Bel-Aire team and thankful to the people she worked with. She was confident in the team she built, often referred to as "Admin Row" and the continued success and growth of Bel-Aire Mechanical.</p>
      
      <p>The entire room cheered as Roxann opened a parting gift from Bel-Aire in appreciation for her dedication, hard work, and exceptional service, an all-expense paid vacation for two to Maui – Four Seasons!</p>
      
      <p>Several others spoke of the impact Roxann had on them through the years. Project Managers made light of her toughness each week reviewing numbers, colleagues remarked on the number of shoes needed to be filled with all she does, and others told of the personal impact she had made in their lives.</p>
      
      <p>Husband Don, daughter Carrie, son-in-law John, and grandkids Allie were there to celebrate this special occasion.</p>
    `
  },
  {
    id: 'st-marys-food-bank-alliance-2015',
    title: 'St. Mary\'s Food Bank Alliance',
    date: '2015-08-15',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/st-marys-food-bank-2015.jpg',
    excerpt: 'Bel-Aire Mechanical teams up with PCL Construction and St. Mary\'s Food Bank to process over 10,000 pounds of food in 3 hours.',
    content: `
      <h3>St. Mary's Food Bank Alliance</h3>
      
      <p>On August 15th, 2015 Bel-Aire Mechanical teamed up with PCL Construction and St. Mary's Food Bank to help provide meals to thousands of individuals in need each day.</p>
      
      <p>It was a hot Saturday in the St. Mary's Food Bank warehouse but the Bel-Aire Mechanical group processed just over 10,000 pounds of food in 3-hours (normally around 8,500 pounds are processed). We checked food items for expiration and damage then sorted items into boxes and bins that were then palletized for shipment. The packaged food from this distribution center can serve 500-900 families each day.</p>
      
      <p>St. Mary's Food Bank says August is a critical time because "demand for assistance increases as kids are going back to school and parents have to stretch their budgets to buy back to school supplies and clothing. Often, this means that families have less to spend on food so they turn to St. Mary's Food Bank and our partner agencies for assistance."</p>
      
      <p>PCL Construction volunteers on a quarterly basis and they open up their volunteer time to anyone who has a Heart to Help. Lourdes Lopez (Project Engineer) at PCL makes sure that the National Association of Women in Construction (NAWIC) gets first dibs on the volunteer slots. With two NAWIC members on the Bel-Aire team, we are happy to join in this worthwhile effort.</p>
      
      <p>Bel-Aire Mechanical's Michelle Dinan-Cardone (Executive Administrator) coordinated the effort for the Bel-Aire group. Representing Bel-Aire Mechanical is Drew Schroder (Construction Director), Kathy Kingsland (HR Manager), Jimmy Pickens (Service Foreman), Chris Cardone (Service Technician), Pam Keller (Service Coordinator) and her son Blake, and Greg Era (IT Manager) and his wife Lisa.</p>
    `
  },
  {
    id: 'desiree-hvacr-today',
    title: 'Desiree HVACR Today',
    date: '2015-09-09',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/desiree-hvacr-2015.jpg',
    excerpt: 'Bel-Aire Mechanical\'s Controller Desiree Zinger is featured in HVACR Today magazine discussing her 30+ years of experience in construction accounting.',
    content: `
      <h3>HVACR Today (September 2015)</h3>
      <h4>"Construction accounting is passion for Bel-Aire controller"</h4>
      
      <p>Bel-Aire Mechanical's Desiree Zinger (Controller) has a feature article in this month's HVACR Today (page 4).</p>
      
      <p>Desiree speaks of her experiences over the past 30+ years in the construction industry and her passion for the challenges in construction accounting.</p>
      
      <p><a href="http://online.hvacrtodayaz.com/?issueID=40&pageID=4" target="_blank" rel="noopener noreferrer">Read the HVACR Today article online now!</a></p>
    `
  },
  {
    id: 'service-dept-uof-phoenix-stadium',
    title: 'Bel-Aire Service Department at University of Phoenix Stadium',
    date: '2015-09-12',
    category: 'Projects',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/uof-phoenix-stadium-2015.jpg',
    excerpt: 'Bel-Aire Mechanical\'s Service Department successfully completes major cooling tower repair at University of Phoenix Stadium just in time for football season kickoff.',
    content: `
      <h3>Just in time for this weekend's Kick-off – University of Phoenix Stadium</h3>
      
      <p>This past Wednesday, with help from Southwest Industrial Rigging, Bel-Aire Mechanical's Service Foreman Jimmy Pickens, along with Industrial Service Technicians Rob Seiler, Chris Cardone and Cody Curtis successfully completed an Axial Fan Assembly replacement on an 800 Ton Cooling Tower at the University of Phoenix Stadium.</p>
      
      <p>This Cooling Tower Repair included the replacement of Pillow-block Bearings, Shaft, Cowlings, Stiffeners, Hubs, Driven Multi-groove Pulley and Installation & Pitch-setting of Blades. The completed assembly spans more than 13 feet in total diameter and weighs just over 1,300 pounds.</p>
      
      <p>Great work done by all!</p>
    `
  },
  {
    id: 'st-marys-food-bank-2015-food-drive',
    title: 'St Mary\'s Food Bank 2015 Food Drive',
    date: '2015-12-08',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/st-marys-food-drive-2015.jpg',
    excerpt: 'Bel-Aire partners with St. Mary\'s Food Bank to host a food drive, collecting over 550 pounds of non-perishable food items to fight hunger in Arizona.',
    content: `
      <h3>Fighting hunger with St. Mary's Food Bank</h3>
      
      <p>Bel-Aire is continuing to partner with St Mary's Food Bank to help FIGHT hunger in Arizona. After spending some time earlier in the year at their warehouse packing over 10,000 pounds of food we wanted to give back in an additional way.</p>
      
      <p>Bel-Aire Mechanical's Michelle Dinan-Cardone (Executive Administrator) coordinated the effort to host a food drive collecting non-perishable food items for the Food Bank to distribute to those most in need. In less than a month, thanks to our generous and thoughtful employees, Bel-Aire raised over 550lbs of Food!!!</p>
      
      <p>Kathy Kingsland (HR Manager) and Greg Era (IT Manager) helped Michelle Dinan-Cardone deliver the food to St Mary's Food bank at the conclusion of the drive.</p>
    `
  },
  {
    id: 'ddwvr-christmas-toy-run',
    title: 'DDWVR Christmas Toy Run',
    date: '2015-12-20',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/christmas-toy-run-2015.jpg',
    excerpt: 'Bel-Aire Mechanical joins contractors at Desert Diamond West Valley Resort to deliver toys, bicycles, clothes and shoes to 25 children in the Tohono O\'odham Nation Christmas Angel program.',
    content: `
      <h3>Sleigh ride to Sells!</h3>
      
      <p>In the holiday spirit of giving back to the community, Bel-Aire Mechanical joined with other contractors at the Desert Diamond West Valley Resort and Casino project to provide gifts for the Tohono O'odham Nation children as part of their Christmas Angel program. These angels are children who have been separated from their families, either in foster care or in the children's home.</p>
      
      <p>Bel-Aire and its employees provided toys, bicycles, clothes and shoes for 25 children that ranged from ages 3 months to 16 years old. In addition, Dave Sain (Estimator) and Scott Kienast (Safety Director) provided additional toys and clothing that were distributed on the day of the event. Back at the Bel-Aire workshop, all of the presents were wrapped and readied for the sleigh ride to Sells, Arizona.</p>
      
      <p>Nancy Garcia (AECOM) expressed her appreciation to all who were involved in the event. "It is hard to express in words how much I appreciate what you did for some of the children on the Tohono O'odham Reservation."</p>
      
      <p>Although there were some children that could not travel to the event, their presents will make it to them.</p>
      
      <p>Robert Dustman (Sr Project Manager) and his wife Kim, Kathy Kingsland (HR Manager) and her daughter Nicole, Torry Martin (Project Superintendent) along with our very own Santa, Frank Nothaft (former Bel-Aire employee) took the trip to Sells this past Sunday to deliver the gifts to the children. The children were so excited to see Santa, commenting that he was the BEST Santa ever!</p>
    `
  },
  {
    id: '2017-heart-walk',
    title: '2017 Heart Walk',
    date: '2017-03-18',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/heart-walk-2017.jpg',
    excerpt: 'Team Bel-Aire participates in the American Heart and American Stroke Association\'s annual Heart Walk, raising over $30,000 for heart health awareness.',
    content: `
      <h3>2017 Heart Walk</h3>
      
      <p>Bel-Aire Mechanical is proud to be a company that places priority on the health of our employees and the health of our community. As a company, we participated in the American Heart and American Stroke Association's annual Heart Walk in Downtown Phoenix on March 18, 2017. Team Bel-Aire raised over $30,000 with the help of our industry vendors!</p>
      
      <p>Jim Dinan led the way for Team Bel-Aire, as we were the only mechanical contractor team for this year's event. We strongly believe in the mission of the American Heart Association and in the value of being involved, both personally and professionally. Together, we can make a difference!</p>
    `
  },
  {
    id: '2017-maggies-place-walk',
    title: '2017 Maggie\'s Place Walk',
    date: '2017-10-08',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/maggies-place-walk-2017.jpg',
    excerpt: 'Bel-Aire Mechanical participates in A Race for Maggie\'s Place 5K Run/Walk for the third year, supporting struggling mothers and their children.',
    content: `
      <h3>2017 Maggie's Place Walk</h3>
      
      <p>This is Bel-Aire's third year participating in A Race for Maggie's Place. On Sunday, October 8th we took to the streets of Tempe for the 5K Run/Walk. By registering and walking we are helping to give struggling mothers the opportunity to build a new life for themselves and enrich the life of their new child.</p>
      
      <p>Team Bel-Aire walkers: Michelle Dinan-Cardone, Chris Cardone, Baby Matteo Cardone, Thom Morrison, Terri Morrison, John Simpson, Sandy Simpson, Kathy Kingsland, Nicole Bell, Jimmy Pickens and Theresa Pickens.</p>
    `
  },
  {
    id: '2017-apprentice-of-the-year-tilden-dickson',
    title: '2017 Apprentice of the Year: Tilden Dickson',
    date: '2017-11-15',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/tilden-dickson-2017.jpg',
    excerpt: 'Tilden Dickson honored as Apprentice of the Year for his outstanding achievements, high grades, and exceptional employer evaluations during his Sheet Metal Apprenticeship.',
    content: `
      <h3>2017 Apprentice of the Year: Tilden Dickson</h3>
      
      <p>It is no surprise that Tilden Dickson ended up in the sheet metal trade, but his recognition as this year's Apprentice of the Year was a welcome and well-earned honor.</p>
      
      <p>Training Director Albert Blanco explains that Tilden was selected as this year's Apprentice of the Year because of his outstanding achievements – including high grades and employer evaluations – during his time at the apprenticeship.</p>
      
      <p>Dickson now emanates a passion for learning new skills, and is pursuing more education and training even though he graduated from the Sheet Metal Apprenticeship earlier this year. He explains, "I don't want to relax; I want to keep learning the trade."</p>
    `
  },
  {
    id: '2017-smacna-safety-excellence-award',
    title: '2017 SMACNA Safety Excellence Award',
    date: '2017-12-01',
    category: 'Awards',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/smacna-safety-award-2017.jpg',
    excerpt: 'Bel-Aire Mechanical receives first place SMACNA Safety Excellence Award for the second consecutive year, recognized for outstanding occupational safety and health.',
    content: `
      <h3>2017 SMACNA Safety Excellence Award</h3>
      
      <p>For the second year in a row Bel-Aire Mechanical was recognized for outstanding occupational safety and health by the national SMACNA association. Bel-Aire was again awarded first place among all SMACNA contractors in the 200,001-300,000 hours category for the second consecutive year.</p>
      
      <p>Scott Kienest (Bel-Aire Mechanical's Safety Director) accepted the first place award at the annual SMACNA on behalf of Bel-Aire Mechanical.</p>
    `
  },
  {
    id: '2017-feed-my-starving-children',
    title: '2017 Feed My Starving Children',
    date: '2017-12-01',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/feed-my-starving-children-2017.jpg',
    excerpt: 'Bel-Aire Mechanical team packs 66,669 meals at Feed My Starving Children MobilePack event, enough to feed 183 children for a year.',
    content: `
      <h3>2017 Feed My Starving Children</h3>
      
      <p>A Bel-Aire Mechanical team of 12 converged on the Phoenix Convention Center on Friday, December 1, 2017 at 4:00 PM to be part of the biggest MobliePack event in the Western United States to support Feed My Starving Children. The goal for each 2-hour packing session during the 3-day event was to pack 40,000 meals. We blew that number out of the water packing 66,669 meals that will feed 183 children for a year We had a lot of fun scooping, sealing, and packing.</p>
      
      <p>Thanks to the following BAM team:</p>
      <p>Justin Smith and his son Hunter<br>
      David Williams, his wife Juanita and their son David<br>
      Scott Williams and his wife Donna<br>
      Michelle Andrews<br>
      Angie Reece and her daughter and son, Naomi and Mason<br>
      Kathy Kingsland</p>
      
      <p>Also part of the team from NAWIC are Stacy Spetter, Centennial Contractors and Sharon Hendrickson, Hendrickson Construction.</p>
      
      <p>Thanks to all for volunteering. If you are interested in helping at future events, please contact Kathy Kingsland at 623.846.8613.</p>
      
      <p>More about Feed My Starving Children: <a href="https://www.fmsc.org" target="_blank" rel="noopener noreferrer">https://www.fmsc.org</a></p>
    `
  },
  {
    id: 'rubys-misting-system-2020',
    title: 'Ruby\'s Misting System',
    date: '2020-08-15',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/rubys-misting-system-2020.jpg',
    excerpt: 'Bel-Aire Mechanical partners with Holder Construction and Make A Wish Arizona to install a high pressure misting system in Ruby\'s backyard.',
    content: `
      <h3>Ruby's Misting System</h3>
      
      <p>Over the summer of 2020, Holder Construction Company invited Bel-Aire to participate in this Make A Wish Arizona opportunity. Russ Hines (Project Manager) coordinated the effort to provide and install a high pressure misting system in Ruby's back yard. Leland Tsosie (Plumbing Foreman) and Erin Etsitty (Plumbing Apprentice) installed the misting system, creating an area cooled by the misters, that Ruby could access easily to enjoy her backyard.</p>
      
      <p>Read more about the project at:<br>
      <a href="https://www.facebook.com/makeawishaz/photos/a.96880338860/10157601293288861/" target="_blank" rel="noopener noreferrer">https://www.facebook.com/makeawishaz/photos/a.96880338860/10157601293288861/</a></p>
    `
  },
  {
    id: 'smacna-bel-aire-banner-desert-medical-center',
    title: 'SMACNA – Bel-Aire at Banner Desert Medical Center',
    date: '2020-11-30',
    category: 'Projects',
    author: 'SMACNA Arizona',
    featuredImage: '/images/news/banner-desert-smacna-2020.jpg',
    excerpt: 'SMACNA Arizona features Bel-Aire Mechanical\'s work on the Banner Desert Medical Center project, highlighting innovative BIM technology and multi-trade modular racks.',
    content: `
      <h3>Bel-Aire Excels on Banner Desert Medical Center</h3>
      
      <p>Bel-Aire Mechanical was selected to provide all HVAC, Plumbing and Medical Gas Systems for the new Banner Desert Medical Center. Bel-Aire's scope of work includes a new 7-story Woman's Tower, Cardon Children's 3rd Floor Build Out, Sophie's Place and Forever Young Renovations, Central Plant Expansion and upgrades, as well as various renovations at existing Towers A, B & C. This multi-phased project began in August 2020 and final completion is slated for November 2023.</p>
      
      <p>Bel-Aire continues to maintain their position as a "top producing contractor" by utilizing state-of-the-art technology and cutting-edge techniques. When the owner required an Integrated Project Delivery (IPD) method, it seemed fitting that Bel-Aire was their top choice. As a design-assist contractor, Bel-Aire was uniquely qualified to participate in this collaborative design and planning approach, allowing the team to provide valuable input early to accommodate the needs of this unique project. COVID-19 produced some unforeseen challenges. The Bel-Aire Team quickly adjusted their work plan to include safe distancing procedures and a slew of virtual meetings.</p>
      
      <h4>3-D Laser Scanning & BIM</h4>
      
      <p>The first task of the project involved 3-D laser scanning of the existing 20,000+ sq. ft. 3rd floor. These scans produced exact locations and dimensions of existing structure and utilities, enabling us to incorporate this information into the 3-D CAD model for a precise layout. Bel-Aire is tracking slightly ahead of schedule and targeting project completion in April 2021. Once built out, this 3rd floor will provide an additional (26) Patient Rooms plus numerous Isolation Rooms, support areas and offices.</p>
      
      <h4>Multi-Trade Modular Racks</h4>
      
      <p>With construction at the 3rd floor well underway, Bel-Aire has shifted BIM modeling efforts to the new 180,000+ sq. ft. 7-story tower. Early construction activities for the tower will begin in the first quarter of 2021. The Bel-Aire Team is in the final stage of design and development to include approximately 2,400' lineal feet of Multi-Trade Modular Racks. The racks will be assembled in Bel-Aire's fabrication shop located in Phoenix and will include ductwork, domestic cold and hot water, heating hot water supply and return, chilled beam water supply and return, chilled water supply and return, medical gas piping, electrical conduits and power feeds and structured cable tray. Assembled modules will be loaded on trucks and shipped to the site for "Just-In-Time" delivery and installation to minimize impacts to the existing hospital activities.</p>
      
      <h4>Central Plant Upgrades</h4>
      
      <p>Central Plant Upgrades will take place in the third-quarter of 2021. These upgrades will include the installation of (2) 1374-ton chillers, various chilled and condenser water pumps, VFD's, pipe headers and valves and DDC controls.</p>
      
      <p>Bel-Aire has service agreements for all Banner chillers and performs various service and repairs at all Banner sites throughout the entire state of Arizona.</p>
      
      <p>Read the full SMACNA article: <a href="http://www.smacna-az.org/bel-aire-excels-on-banner-desert-medical-center/" target="_blank" rel="noopener noreferrer">SMACNA AZ » Bel-Aire Excels on Banner Desert Medical Center</a></p>
    `
  },
  {
    id: '2020-phoenix-rescue-mission',
    title: '2020 Phoenix Rescue Mission',
    date: '2020-12-15',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/phoenix-rescue-mission-2020.jpg',
    excerpt: 'Bel-Aire Mechanical team brings more than 400 donations to the Phoenix Rescue Mission\'s 2020 Holiday Drive, supporting those in need during the holiday season.',
    content: `
      <h3>2020 Phoenix Rescue Mission</h3>
      
      <p>Bel-Aire would like to thank and congratulate our team that worked together to bring more than 400 donations for the Phoenix Rescue Mission's 2020 Holiday Drive!</p>
    `
  },
  {
    id: 'kitchen-on-the-street',
    title: 'Kitchen On The Street',
    date: '2021-01-20',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/kitchen-on-the-street.jpg',
    excerpt: 'Bel-Aire Mechanical proudly sponsors Kitchen On The Street and supports NAWIC members who provide vital community services to those in need.',
    content: `
      <h3>Kitchen On The Street</h3>
      
      <p>As a company sponsor, Bel-Aire is proud of the support that Kitchen On The Street provides and of our NAWIC members that continually perform such appreciated works for our community!</p>
      
      <p>Read more on opportunities like this:<br>
      <a href="https://www.facebook.com/Kitchen-on-the-Street-85435703923" target="_blank" rel="noopener noreferrer">https://www.facebook.com/Kitchen-on-the-Street-85435703923</a></p>
    `
  },
  {
    id: 'boeing-topping-out-2021',
    title: 'Boeing Topping Out',
    date: '2021-03-29',
    category: 'Projects',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/boeing-topping-out-2021.jpg',
    excerpt: 'Boeing project celebrates their Topping Out ceremony as the last piece of steel is flown into place, marking a major milestone in construction.',
    content: `
      <h3>Boeing Topping Out</h3>
      
      <p>Monday March 29th, 2021, the Boeing project celebrated their Topping Out. Flying the last piece of steel to set in place is always a site to see!</p>
    `
  },
  {
    id: 'mentoring-each-other-nawic',
    title: 'Mentoring Each Other',
    date: '2021-05-15',
    category: 'Company News',
    author: 'Nora Burba Trulsson / Source Design',
    featuredImage: '/images/news/mentoring-each-other-2021.jpg',
    excerpt: 'Kathy Kingsland, Bel-Aire\'s HR Manager, shares her construction career experience and NAWIC involvement in a featured Source Design article about professional women\'s groups.',
    content: `
      <h3>Mentoring Each Other</h3>
      <h4>Professional Women's groups in Arizona offer support, networking and friendship</h4>
      
      <p>Bel-Aire Mechanical would like to share a featured article from Source Design written by Nora Burba Trulsson.</p>
      
      <p>Kathy Kingsland (Bel-Aire's HR Manager) shares her experience in her construction career and her involvement with NAWIC, the National Association of Women In Construction.</p>
      
      <p>Read the full article:<br>
      <a href="https://sourcesfordesign.com/sources/issue-28/#16" target="_blank" rel="noopener noreferrer">Mentoring Each Other – Professional Women's groups in Arizona</a></p>
    `
  },
  {
    id: 'covid-19-standards-and-planning',
    title: 'Bel-Aire Mechanical Keeps Standards High During COVID-19, and Plans Ahead',
    date: '2021-06-20',
    category: 'Safety',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/covid-19-safety-2021.jpg',
    excerpt: 'Bel-Aire Mechanical maintains exceptional health and safety standards during the pandemic while delivering outstanding work on major projects and planning for future growth.',
    content: `
      <h3>Bel-Aire Mechanical Keeps Standards High During COVID-19, and Plans Ahead</h3>
      
      <p>Even in non-pandemic times, Bel-Aire Mechanical leads the way in terms of worker health and safety on the jobsite. It's no wonder facing the unique jobsite challenges presented by COVID-19 – distributing additional PPE, contact tracing and increased cleaning – came naturally to Bel-Aire's leadership team and employees.</p>
      
      <p>Robert Dustman, Project Director for Bel-Aire Mechanical, credits the company's existing commitment to on-the-job safety for the minimal COVID-19 outbreaks they experienced over the past 12+ months.</p>
      
      <p>"As a company we have done such a great job adapting to the new health and safety protocols, even as we deal with different requirements and standards on each unique site," says Robert.</p>
      
      <p>"We have always set the standard on the jobsite when it comes to safety, and through the pandemic, we continue to see workers and contractors on different projects following Bel-Aire's lead."</p>
      
      <h4>Delivering Quality During the Pandemic</h4>
      
      <p>Throughout this past year, Bel-Aire Mechanical has adapted to the pandemic while still delivering outstanding quality products to owners throughout the state. This is evidenced by the company's work on the Desert Diamond Casino, the Banner Desert facility in Mesa, and the Boeing manufacturing facility.</p>
      
      <h4>Planning for Growth</h4>
      
      <p>It is no secret that the construction industry in Arizona is hot right now, and only going to get hotter in the coming months. While continuing to deliver high-quality work to owners during the pandemic, Bel-Aire Mechanical simultaneously planned for this impending increase in workload for the coming year.</p>
    `
  },
  {
    id: 'smacna-az-fall-2021-golf-tournament',
    title: 'SMACNA-AZ Fall 2021 Golf Tournament',
    date: '2021-09-10',
    category: 'Company News',
    author: 'SMACNA Arizona',
    featuredImage: '/images/news/smacna-golf-2021.jpg',
    excerpt: 'Bel-Aire Mechanical sponsors winning team at SMACNA-AZ Annual Golf Tournament, with multiple Bel-Aire teams placing in top positions and winning awards.',
    content: `
      <h3>SMACNA-AZ Fall 2021 Golf Tournament</h3>
      <h4>Thanks to Annual Golf Tournament Participants</h4>
      
      <p>We want to thank everyone who participated in our Annual Golf Tournament on September 10. Thank you to our sponsors and volunteers who made the tournament a huge success. Congratulations to our winning teams.</p>
      
      <h4>Tournament Winners</h4>
      
      <p><strong>First place team sponsored by Bel-Aire Mechanical:</strong> Jim Dinan (emcee), Chris Cardone, Justin Smith, Jimmy Pickens and Cody Curtis (not pictured).</p>
      
      <p><strong>Second place team sponsored by Southland Industries:</strong> Jim Dinan (emcee), Zach Washburn, Tommy Holt, Carl Winter and Craig Barns.</p>
      
      <p><strong>Third place team sponsored by Superior Duct Fabrication:</strong> Jim Dinan (emcee), Scott Kienast, JP Long, and Brandon Avilla from Bel-Aire Mechanical, and Steve Pedroza from Superior Duct Fabrication.</p>
      
      <p><strong>Integrity Award:</strong> Kristine Brain, Stacey Castner, Natalie Bouley, and Cat Hauser from Bel-Aire Mechanical. The foursome won $500 each presented by Jeff Holly (pictured) of SMART Local 359 and the Wheelbarrow of Spirits sponsored by Varitec.</p>
    `
  },
  {
    id: 'smacna-hvac-phoenix-is-booming',
    title: 'SMACNA - December 2021: HVAC Phoenix is Booming',
    date: '2021-12-01',
    category: 'Company News',
    author: 'Robert Dustman / SMACNA',
    featuredImage: '/images/news/hvac-phoenix-booming-2021.jpg',
    excerpt: 'Robert Dustman shares insights on Phoenix\'s booming HVAC industry, covering major data centers for tech giants and Arizona\'s premier healthcare facilities.',
    content: `
      <h3>HVAC Phoenix is Booming</h3>
      
      <p>Follow the link below to read about Robert Dustman's take on HVAC in Phoenix. From big corporate data centers like Google, Facebook and Yahoo to Arizona's finest hospitals including Banner Health, Dignity Health and Mayo clinics, Robert's well spoken article covers it all.</p>
      
      <p>Read the full SMACNA article:<br>
      <a href="https://www.smacna.org/stay-informed/news-and-publications/smacnews/2021-issues/smacnews-nov-dec-2021/hvac-phoenix-is-booming" target="_blank" rel="noopener noreferrer">HVAC Phoenix is Booming - SMACNA News</a></p>
    `
  },
  {
    id: 'construction-career-education-day-2022',
    title: 'Construction Career Education Day 2022',
    date: '2022-03-15',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/career-education-day-2022.jpg',
    excerpt: 'Bel-Aire Mechanical team members share insights about working in the construction industry at Construction Career Education Day.',
    content: `
      <h3>Construction Career Education Day 2022</h3>
      
      <p>Follow the link below to listen to one of Bel-Aire Mechanical's very own briefly talk about what it means to work in the construction industry.</p>
      
      <p>Watch the video:<br>
      <a href="https://www.youtube.com/watch?v=HAsfbpktwuc" target="_blank" rel="noopener noreferrer">Construction Career Education Day 2022 - YouTube</a></p>
    `
  },
  {
    id: 'ranking-arizona-top-10-mechanical-contractors-2023',
    title: 'Ranking Arizona: Top 10 Mechanical Contractors for 2023',
    date: '2023-01-15',
    category: 'Awards',
    author: 'Arizona Big Media',
    featuredImage: '/images/news/ranking-arizona-2023.jpg',
    excerpt: 'Bel-Aire Mechanical recognized in Ranking Arizona\'s Top 10 Mechanical Contractors for 2023, showcasing industry excellence and leadership.',
    content: `
      <h3>Ranking Arizona: Top 10 Mechanical Contractors for 2023</h3>
      
      <p>Follow the link below to see Bel-Aire Mechanical's Ranking in Arizona.</p>
      
      <p>View the rankings:<br>
      <a href="https://azbigmedia.com/business/ranking-arizona-top-10-mechanical-contractors-for-2023/" target="_blank" rel="noopener noreferrer">Ranking Arizona: Top 10 Mechanical Contractors for 2023</a></p>
    `
  },
  {
    id: '2023-arizona-pipe-trades-apprenticeship-contest',
    title: '2023 Arizona Pipe Trades Apprenticeship Contest',
    date: '2023-04-29',
    category: 'Company News',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/pipe-trades-contest-2023.jpg',
    excerpt: 'Congratulations to Brent Larsen on winning first place at the 2023 Arizona Pipe Trades Apprenticeship Contest, earning advancement to Regional competition in Las Vegas.',
    content: `
      <h3>2023 Arizona Pipe Trades Apprenticeship Contest</h3>
      
      <p><strong>Congratulations Brent Larsen on your local win!</strong></p>
      <p><strong>Best of luck to you at Regionals!</strong></p>
      
      <p>The 2023 Arizona Pipe Trades Apprenticeship contest was held on April 29th at the UA Local 469 training center. This annual contest is designed to test the skills of pipefitters, plumbers, and HVAC professionals associated with UA Local 469. The event was divided into three parts: a 4-hour piping project, a 1-hour 50-question essay-style answer test, and a 2-hour schematic drawing/wiring project, which added up to a total of 10 hours.</p>
      
      <h4>Contest Details</h4>
      
      <p>Mike Dooher and Matt Leach were the proctors for the contest, while Rick Wieting (Retiree) and Ross Hanley (Tolin Mechanical) served as the judges. The competition was very close, with a tight point position between the top two contestants. Ultimately, Brent Larsen won first place, receiving a $500 cash prize, a name-brand welding hood, a hard-case ice chest, a Milwaukee tool bag filled with goodies, a gift card, and several other miscellaneous items.</p>
      
      <h4>Advancing to Regionals</h4>
      
      <p>Brent will be advancing to the Regional Level of the contest, which will take place in mid-June in Las Vegas. Matt Leach will accompany Brent as his coach, hoping to bring home a win for Local 469 and move on to the National Competition in Ann Arbor, Michigan.</p>
      
      <h4>About the Competition</h4>
      
      <p>This annual competition is an excellent opportunity for aspiring pipefitters, plumbers, and HVAC professionals to showcase their skills and learn from their peers. It also serves as a platform for industry sponsors, such as Milwaukee, to support and showcase their latest products and tools.</p>
      
      <p>The UA Local 469 training center is committed to providing high-quality training and education to its apprentices, ensuring that they are well-equipped to meet the demands of the ever-evolving industry. The annual apprenticeship contest is just one of the ways in which UA Local 469 supports and promotes its members' ongoing education and professional development.</p>
      
      <p>In conclusion, the 2023 Arizona Pipe Trades Apprenticeship contest was a great success, highlighting the skills and expertise of the industry's rising stars. Congratulations to Brent for winning first place and best of luck to him and Matt as they move on to the Regional Level of the contest.</p>
    `
  },
  {
    id: '2024-help-fill-the-toy-closet-foundation',
    title: '2024 Help Fill The Toy Closet Foundation',
    date: '2024-05-04',
    category: 'Community',
    author: 'Bel-Aire Communications Team',
    featuredImage: '/images/news/toy-closet-2024.jpg',
    excerpt: 'Robert Dustman joins HFTTC committee as Bel-Aire Mechanical continues supporting the annual golf tournament and mission to bring joy to hospitalized children.',
    content: `
      <h3>Help Fill The Toy Closet Foundation</h3>
      
      <p>In 2023, Robert Dustman of Bel-Aire became a HFTTC committee member. "I'm fortunate to work with a wonderful group of caring individuals whose goal is to bring a little happiness to these kids," Robert shared.</p>
      
      <h4>2024 Golf Tournament Success</h4>
      
      <p>One of our most popular fundraising events is the HFTTC Golf Tournament. This year's tournament took place on May 4, 2024, at the Whirlwind Golf Club. Bel-Aire has proudly served as the event's Photo Sponsor since its inception. This year's sold-out event was another tremendous success.</p>
      
      <h4>Over a Decade of Brightening Lives</h4>
      
      <p>Since its inaugural toy drive in 2009, HFTTC has been brightening children's lives for over a decade, thanks to the dedication of its committee members and the support of the community. Bel-Aire Mechanical enthusiastically joined the cause, providing invaluable support from the start.</p>
      
      <h4>The Mission</h4>
      
      <p>Hospitals are often filled with children facing serious illnesses, making it an incredibly challenging time for both the children and their families. The Help Fill The Toy Closet Foundation (HFTTC) was established to bring joy to these young patients. HFTTC organizes local fundraisers to maintain a well-stocked toy closet, because every child deserves the happiness that toys can bring.</p>
    `
  }
];

export const newsCategories = [
  'All',
  'Awards',
  'Company News',
  'Community',
  'Events',
  'Projects',
  'Safety'
];
